const fieldDefinitions = {
    product: [
        ['nameEn', 'عنوان انگلیسی محصول / مقاله', 500],
        ['fieldEn', 'حوزه انگلیسی (فقط برای نمایش)', 200],
        ['descriptionEn', 'توضیحات / متن مقاله به انگلیسی (Markdown)', 100000, true],
        ['authorNameEn', 'نام نویسنده به انگلیسی', 500],
        ['authorDescriptionEn', 'درباره نویسنده به انگلیسی (Markdown)', 50000, true]
    ],
    course: [
        ['nameEn', 'نام دوره به انگلیسی', 500],
        ['fieldEn', 'حوزه انگلیسی (فقط برای نمایش)', 200],
        ['descriptionEn', 'درباره دوره به انگلیسی (Markdown)', 100000, true],
        ['headlineEn', 'سرفصل‌های دوره به انگلیسی (Markdown)', 50000, true],
        ['aboutTeacherEn', 'درباره مدرس به انگلیسی (Markdown)', 50000, true]
    ],
    service: [['nameEn', 'نام خدمت به انگلیسی', 500], ['fieldEn', 'حوزه انگلیسی (فقط برای نمایش)', 200]],
    event: [['nameEn', 'نام رخداد به انگلیسی', 500]],
    gallery: [['nameEn', 'نام تصویر به انگلیسی', 500], ['altEn', 'توضیح جایگزین تصویر به انگلیسی (Alt)', 2000, true]]
};

export function getEnglishContent(resource, record = {}) {
    return Object.fromEntries(fieldDefinitions[resource].map(([field]) => [field, typeof record[field] === 'string' ? record[field] : '']));
}

export default function EnglishContentFields({ resource, value, onChange }) {
    return (
        <fieldset className="english-content-fields border rounded p-3 my-3 w-100" dir="rtl">
            <legend className="float-none w-auto px-2" style={{ fontSize: '1rem' }}>محتوای انگلیسی (اختیاری)</legend>
            <p className="mb-3 small">در صورت خالی بودن هر فیلد انگلیسی، متن فارسی همان فیلد در سایت نمایش داده می‌شود. حوزه‌ها و پیش‌نیازهای اصلی را تغییر ندهید.</p>
            <div className="row">
                {fieldDefinitions[resource].map(([field, label, maxLength, multiline]) => {
                    const id = `english-${resource}-${field}`;
                    const properties = {
                        id, name: field, value: value[field] || '', dir: 'ltr', lang: 'en', maxLength,
                        onChange: (event) => onChange((previous) => ({ ...previous, [field]: event.target.value })),
                        className: 'w-100', style: { textAlign: 'left' }
                    };
                    return (
                        <div className={multiline ? 'col-12' : 'col-12 col-md-6'} key={field}>
                            <div className="form-group">
                                <label htmlFor={id} className="mb-2">{label}</label>
                                {multiline ? <textarea {...properties} rows={5} /> : <input {...properties} type="text" />}
                            </div>
                        </div>
                    );
                })}
            </div>
        </fieldset>
    );
}
